import React, {useContext, createContext, useState, useEffect} from 'react';

const AlertContext = createContext();

export const AlertProvider = ({children}) => {
    const [data, setData] = useState({message: "", status: "", showAlert: false});
    // const [showAlert, setShowAlert] = useState({request: false, create_app: false});
    const updateAlertStatus = (show, type) => setData(prev => ({ ...prev, showAlert: show }));

    const updateAlert = (message, status, show, type) => {
        setData({message: message, status: status, showAlert: show});
        setTimeout(() => {
            setData({message: "", status: "", showAlert: false});
        }, 5000);
    }

    const value = {
        state: {
            data
        },
        updateAlert,
        updateAlertStatus
    }

    return (
        <AlertContext.Provider value={value}>
          {children}
        </AlertContext.Provider>
      );
}

export const useAlert = () => useContext(AlertContext);